import { mivoDb } from "@/domains/offline/db/mivoDb";
import type { PatientListRow, SessionRow } from "@/domains/offline/db/schema";
import { normalizeApiPath } from "@/domains/offline/guards/offlineCapability";

function sanitizePatientList(rows: PatientListRow[]): PatientListRow[] {
  return rows.map((row) => ({
    id: String(row.id ?? ""),
    name: row.name ?? null,
    clinicId: row.clinicId ?? null,
    parentId: row.parentId ?? null,
    primaryTherapistId: row.primaryTherapistId ?? null,
    primaryTherapistName: row.primaryTherapistName ?? null,
    hasActiveLink: row.hasActiveLink ?? null,
    myLinkEndedAt: row.myLinkEndedAt ?? null,
    guardianAccountLinked: row.guardianAccountLinked ?? null,
    isClinicSharedForMe: row.isClinicSharedForMe ?? null,
    isClinicPrimaryForMe: row.isClinicPrimaryForMe ?? null,
    activeCareLinks: row.activeCareLinks ?? null,
  }));
}

function sanitizeSessions(rows: SessionRow[]): SessionRow[] {
  return rows.map((row) => ({
    id: String(row.id ?? ""),
    patientId: row.patientId ?? null,
    patientName: row.patientName ?? null,
    therapistId: row.therapistId ?? null,
    therapistName: row.therapistName ?? null,
    therapistSpecialty: row.therapistSpecialty ?? null,
    scheduledAt: row.scheduledAt ?? null,
    durationMinutes: row.durationMinutes ?? null,
    status: row.status ?? null,
    location: row.location ?? null,
  }));
}

export async function persistGetResponse(url: string, data: unknown, params?: Record<string, unknown>): Promise<void> {
  const path = normalizeApiPath(url);

  if (path === "/patients" && Array.isArray(data)) {
    await mivoDb.patients.clear();
    await mivoDb.patients.bulkPut(sanitizePatientList(data as PatientListRow[]));
    return;
  }

  if (path === "/sessions" && Array.isArray(data)) {
    await mivoDb.sessions.clear();
    await mivoDb.sessions.bulkPut(sanitizeSessions(data as SessionRow[]));
    return;
  }
}

export async function applyOptimisticMutation(_method: string, _url: string, _body: unknown): Promise<void> {}

export async function mapTempId(tempId: string, serverId: string, entity: string): Promise<void> {
  await mivoDb.idMappings.put({ tempId, serverId, entity, createdAt: Date.now() });
}
